/**
 * @generated SignedSource<<311788f9664db5ae59fd7085f4d05abc>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { Fragment, ReaderFragment } from 'relay-runtime';
type ShowMoreFooter_connection$fragmentType = any;
type SuitesChooser_team$fragmentType = any;
export type SuiteAccessLevels = "MANAGE_AND_READ" | "READ_ONLY" | "%future added value";
import type { FragmentType } from "relay-runtime";
declare export opaque type Suites_team$fragmentType: FragmentType;
export type Suites_team$data = {|
  +suites: ?{|
    +count: number,
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +accessLevel: SuiteAccessLevels,
        +id: string,
        +permissions: {|
          +teamSuiteDelete: ?{|
            +allowed: boolean,
          |},
          +teamSuiteUpdate: ?{|
            +allowed: boolean,
          |},
        |},
        +suite: ?{|
          +id: string,
          +name: string,
          +slug: string,
          +url: string,
        |},
      |},
    |}>,
    +$fragmentSpreads: ShowMoreFooter_connection$fragmentType,
  |},
  +$fragmentSpreads: SuitesChooser_team$fragmentType,
  +$fragmentType: Suites_team$fragmentType,
|};
export type Suites_team$key = {
  +$data?: Suites_team$data,
  +$fragmentSpreads: Suites_team$fragmentType,
  ...
};
*/

var node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "allowed",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "pageSize"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "Suites_team",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SuitesChooser_team"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "pageSize"
        },
        {
          "kind": "Literal",
          "name": "order",
          "value": "NAME"
        }
      ],
      "concreteType": "TeamSuiteConnection",
      "kind": "LinkedField",
      "name": "suites",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ShowMoreFooter_connection"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TeamSuiteEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TeamSuite",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "accessLevel",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Suite",
                  "kind": "LinkedField",
                  "name": "suite",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "slug",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "url",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TeamSuitePermissions",
                  "kind": "LinkedField",
                  "name": "permissions",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Permission",
                      "kind": "LinkedField",
                      "name": "teamSuiteUpdate",
                      "plural": false,
                      "selections": (v1/*: any*/),
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Permission",
                      "kind": "LinkedField",
                      "name": "teamSuiteDelete",
                      "plural": false,
                      "selections": (v1/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Team",
  "abstractKey": null
};
})();

(node/*: any*/).hash = "db6ee1fd2a9f9cc9279d009425056191";

module.exports = ((node/*: any*/)/*: Fragment<
  Suites_team$fragmentType,
  Suites_team$data,
>*/);
